import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { isUserAuthenticated } from "./WorkerService";
import Header from "./Header";

const Welcome: React.FC = () => {

    useEffect(() => {
        const checkIfloggedIn = async () => {
            if(!await isUserAuthenticated()){
                window.location.href = "/login";
            }
        }
        checkIfloggedIn();
    }, [])

    return (
        <div className="data-capture-container align-items-center">
            <Header title="WELCOME"/>
            <div className='welcome-message mt-3'>
                <div className="mt-5 text-center">
                    <h5>Welcome to the <br/>Risk iQ Grey Fleet Portal</h5>
                </div>
                <div className="mt-3 mx-5 text-center">
                    <p />As your Driver Risk Management provider, 
                    we are required to ensure all grey fleet drivers are safe, 
                    legal and compliant when driving on company business. 
                    Your driver record states that you are a grey fleet driver 
                    and use your own vehicle for work purposes and 
                    claim mileage expenses through your employer.  
                    <p/> To ensure you are fully compliant, we require you to provide the required information.
                </div>
                <div className='mt-5'>
                    <Link className="" to={'/datacapture'} >
                        <Button type="button"  
                            className='button'
                            style={{width:"175px"}}>
                            GET STARTED
                        </Button> 
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Welcome;